import { Reveal } from "@/motion";
import { Section } from "@/components/Section";

export function BrandIntro() {
  return (
    <Section id="brand" labelledBy="brand-title">
      <div className="split">
        <Reveal as="div" className="split__lead" distance={24}>
          <p className="eyebrow">The brand</p>
          <h2 id="brand-title" className="section__title">
            Different pace.
            <br />
            Shared progress.
          </h2>
        </Reveal>

        <Reveal as="div" className="split__body" distance={12} delay={0.1}>
          <p>
            Path &amp; Pace started from a simple observation: everyone is running
            a different route, at a different speed, for a different reason — and
            almost none of it looks like the marketing.
          </p>
          <p>
            So we build for the actual thing. Kit that breathes when you slow
            down, holds up when you don't, and doesn't announce itself either way.
          </p>
          <p className="split__pull">Two paths. One direction.</p>
        </Reveal>
      </div>
    </Section>
  );
}
